<template>
  <Slideover :visible="visible">
    <header class="px-2 py-3 sm:px-6 bg-green-600 text-white">
      <div class="flex items-start justify-between space-x-3">
        <h2 class="text-lg leading-7 font-medium">
          {{ title }}
        </h2>
        <div class="h-7 flex items-center">
          <button
            type="button"
            aria-label="Close panel"
            @click="$emit('toggle-slideover')"
            class="text-green-300 hover:text-white transition ease-in-out duration-150"
          >
            <icon set="solid" name="x" class="flex-shrink-0 m-1 h-5 w-5" />
          </button>
        </div>
      </div>
    </header>
    <div class="px-4 py-2">
      <div class="flex flex-col space-y-4">
        <div class="text-lg text-center my-4">Updating this value will also update it for individual items.</div>
        <div class="flex justify-center">
          <div class="w-32">
            <v-date-picker
              v-model="expectedShipDate"
              color="green"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="px-4 py-2">
      <div class="flex justify-center">
        <span v-if="error" class="text-red-500">Something went wrong!</span>
      </div>
      <div class="flex justify-center">
        <Button
          @click-handler="updateExpectedShipDate"
          :disabled="processing"
          class="flex items-center space-x-2"
        >
          <span>Update</span>
          <LoadingSpinner v-if="processing" class="text-white" />
        </Button>
      </div>
    </div>
  </Slideover>
</template>

<script>
import { ApiFactory } from "@/api/ApiFactory.js";
import Button from "@/components/elements/Button.vue";
import Slideover from "@/components/layout/Slideover.vue";

const Order = ApiFactory.get('orders');


export default {
  name: "EditOrderExpectedShipDate",
  components: {
    Button,
    Slideover
  },
  props: {
    title: {
      type: String,
      default: "Title"
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      expectedShipDate: null,
      processing: false,
      error: false,
    };
  },
  computed: {
    order() {
      return this.$store.getters["orders/get"]("order");
    },
  },
  created() {
    this.setExpectedShipDate(this.order?.ExpectedShipDate);
  },
  methods: {
    setExpectedShipDate(value) {
      if (! value) {
        return;
      }

      try {
        this.expectedShipDate = new Date(value);
      } catch (e) {
        this.expectedShipDate = null;
      }
    },
    updateExpectedShipDate() {
      this.error = false;
      this.processing = true;
      Order.editOrderExpectedShipDate(this.order.SourceOrderNumber, {
        expected_ship_date: this.expectedShipDate.toISOString().substr(0, 10)
      }).then(() => {
        this.$emit('toggle-slideover');
        this.reloadRelatedInformation();
      }).catch(() => {
        this.error = true;
      }).finally(() => {
        this.processing = false;
      });
    },
    reloadRelatedInformation() {
      this.$store.dispatch("orders/refreshOrder", this.order.SourceOrderNumber);
    },
  }
};
</script>
